import type { MonospaceSingleConstraint, MonospaceSingleConstraintField } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';
import { compositeKey } from '~/rstore/utils/composite-key';

export const SingleConstraintField = withItemType<MonospaceSingleConstraintField>().defineCollection({
	name: 'MonospaceSingleConstraintField',
	scopeId: MONOSPACE_SCOPE_ID,
	getKey: (item) => compositeKey(item.constraintId, item.constrainedFieldId, item.referencedFieldId),
	meta: {
		defaultFields: ['order', 'constraintId', 'constrainedFieldId', 'referencedFieldId'],
	},
});

export const SingleConstraint = withItemType<MonospaceSingleConstraint>().defineCollection({
	name: 'MonospaceSingleConstraint',
	scopeId: MONOSPACE_SCOPE_ID,
	meta: {
		defaultFields: ['id', 'dbName', 'onDelete', 'onUpdate'],
	},
});
